import { XCircleIcon } from "@heroicons/react/20/solid";

export default function ErrorAlert({ text }: { text: string }) {
	return (
		<div className="bizF-rounded-md bizF-bg-red-50 bizF-p-4 bizF-mt-2">
			<div className="bizF-flex">
				<div className="bizF-flex-shrink-0">
					<XCircleIcon
						className="bizF-h-5 w-5 bizF-text-red-400"
						aria-hidden="true"
					/>
				</div>
				<div className="bizF-ml-3">
					<h3 className="bizF-text-sm bizF-mt-0 bizF-font-medium bizF-text-red-800">
						{text}
					</h3>
				</div>
			</div>
		</div>
	);
}
